import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name"];
import MUIDatePicker from "@mui/lab/DatePicker";
import { TextField } from "@mui/material";
import { useField } from "formik";
import React, { useCallback } from "react";
import { composeEventWithValue } from "../../../helpers";
import styles from "./datepicker.module.less";
export var DatePicker = function DatePicker(_ref) {
  var _props$renderInput;

  var name = _ref.name,
      props = _objectWithoutProperties(_ref, _excluded);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useField = useField(name),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      helpers = _useField2[2];

  var onChange = useCallback(function (newValue) {
    helpers.setValue(newValue);
    var event = composeEventWithValue(newValue);
    if (props.onChange) props.onChange(event);
  }, [helpers, props]);
  var renderInput = (_props$renderInput = props.renderInput) !== null && _props$renderInput !== void 0 ? _props$renderInput : function (params) {
    return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      className: styles.textField,
      hiddenLabel: true,
      helperText: null
    }));
  };
  return /*#__PURE__*/React.createElement(MUIDatePicker, _extends({}, props, {
    renderInput: renderInput,
    value: field.value,
    onChange: onChange
  }));
};